module.exports = __webpack_public_path__ + "static/media/swimmy-creation-mobile.5603f7db.png";